import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ISolicitudPersonaModel } from 'src/app/models/interfaces/solicitud/ISolicitudPersonaModel';
import { PersonalModel } from 'src/app/models/solicitud/PersonalModel';
import { SolicitudPersonaDocumentosService } from 'src/app/services/solicitud-persona-documentos/solicitud-persona-documentos.service';
import { SolicitudPersonaService } from 'src/app/services/solicitud-persona/solicitud-persona.service';
import * as fileSaver from 'file-saver';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';
import { SolicitudSeccion } from 'src/app/models/common/enumModel';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';

@Component({
  selector: 'app-personal-readonly-dialog',
  templateUrl: './personal-readonly-dialog.component.html',
  styleUrls: ['./personal-readonly-dialog.component.css']
})
export class PersonalReadonlyDialogComponent implements OnInit {
  model!: ISolicitudPersonaModel;
  displayedColumns: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento'
  ];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PersonalReadonlyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ISolicitudPersonaModel,
    private solicitudPersonaService: SolicitudPersonaService,
    private solicitudPersonaDocumentoService: SolicitudPersonaDocumentosService,
  ) {
    this.model = new PersonalModel();
  }

  ngOnInit(): void {
    this.solicitudPersonaService.getById(this.data.idSolicitud, this.data.idSolicitudPersona).subscribe(p => {
      this.model = p;
      this.model.idSolicitud = this.data.idSolicitud;
      this.model.codigoSolicitud = this.data.codigoSolicitud;
      this.model.logs = this.model.logs.filter(p => p.comentarios != "");
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  downloadDocumentFromService(element: DocumentacionRequeridaModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Personal;
      modelVisor.idRegistro = this.data.idSolicitudPersona;
      modelVisor.idSolicitudDocumento = element.idSolicitudPersonaDocumento;
      modelVisor.codigoSolicitud = this.model.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudPersonaDocumentoService.downloadDocumento(
        this.model.codigoSolicitud,
        this.model.idSolicitudPersona,
        element.idSolicitudPersonaDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);

      });
    }
  }
}
